import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { first } from "rxjs/operators";

import { KATZWizardComponent } from "../components/katz-wizard/katz-wizard.component";

@Injectable()
export class KATZWizardService {
	private readonly matDialog = inject(MatDialog);

	openKATZWizard(katz: string, isDemented = false) {
		const modalRef = this.matDialog.open(KATZWizardComponent, {
			hasBackdrop: true,
			width: "835px",
			height: "750px",
			disableClose: true,
			data: {
				katz,
				isDemented,
			},
		});

		return modalRef.afterClosed().pipe(first<number>());
	}
}
